<template>
<div class="MConfirmOrder m-order" v-if="init">
    <mOrderHeader :item="item"></mOrderHeader>
    <div class="m-body">
        <div class="couponCode" @click="openSelectCoupon" v-if="item.couponvoucherlist">
            <!-- <div class="left">优惠券/兑换码</div> -->
            <div class="left">优惠券</div>
            <div class="right">
                <span v-if="selectCoupon === -1 && item.couponvoucherlist.length">去使用</span>
                <span v-else-if="selectCoupon === -1 && !item.couponvoucherlist.length">无可用</span>
                <div class="discountmoney" v-else>
                    {{item.couponvoucherlist[selectCoupon].prefercontent}}<span v-if="item.couponvoucherlist[selectCoupon].voucherdistype === 1">减{{item.couponvoucherlist[selectCoupon].faceprice}}</span><span v-if="item.couponvoucherlist[selectCoupon].voucherdistype === 2">打{{item.couponvoucherlist[selectCoupon].voucherdisrate}}折</span>
                </div>
                <img :src="require('@/common/images/index/icon-right.png')" alt="">
            </div>
        </div>
    </div>
    <div class="m-body">
        <div class="box" v-if="item.uprice > item.saleprice">
            <div class="name">商品原价</div>
            <div class="value">￥{{item.uprice}}</div>
        </div>
        <div class="box nowprice">
            <div class="name">商品现价</div>
            <div class="value">￥{{item.saleprice}}</div>
        </div>
        <div class="box nowprice" v-if="item.islimitcount">
            <div class="name">限时折扣</div>
            <div class="value">￥{{item.limitprice}}</div>
        </div>
        <div class="box nowprice" v-if="item.isplusprice">
            <div class="name">PLUS价</div>
            <div class="value">￥{{item.plusprice}}</div>
        </div>
        <div class="box coupon" v-if="selectCoupon !== -1">
            <div class="name">优惠券</div>
            <div class="value">-￥{{discountmoney}}</div>
        </div>
        <!-- <div class="box code" v-if="code">
            <div class="name">兑换码</div>
            <div class="value">-￥{{code}}</div>
        </div> -->
        <!-- <div class="box">
            <div class="name">小计</div>
            <div class="value tc-red">￥{{saleprice}}</div>
        </div> -->
    </div>
    <div class="exchange_tips" @click="changeExchangeDialog" v-if="kmctype == '7' || kmctype == '8' || kmctype == '2' || kmctype == '3'">
        我有兑换码，点击兑换>>
    </div>
    <!-- <div class="tip">
        <span>注意：订单不支持退款、转让，提交订单则表示恁同意</span>
        <span class="tc-blue">《用户付费协议》</span>
    </div> -->
    <div class="bottomMsgBox">
        <div class="checkBox">
            <van-checkbox shape="square" icon-size="16px" v-model="agreement"></van-checkbox>
            <div class="textBox">
                <span class="tips">勾选即表示同意</span>
                <a href="http://m.capwhale.com//index/mPayTerms.html">《快捷支付服务协议》</a>
                <a href="http://m.capwhale.com//index/mPayUserTerms.html">《微信支付用户服务协议》</a>
            </div>
        </div>
        <div class="btnBox">
            <div class="price">
                <span class="tc-black name" @click="pay">实际支付：</span>
                <span class="tc-red value">￥{{saleprice}}</span>
            </div>
            <div class="btn">
                <van-button class="cancel" type="default" @click="pay">立即支付</van-button>
            </div>
        </div>
    </div>
    <selectCoupon @affirmCoupon="affirmCoupon" ref="selectCoupon" />
    <FormDialog ref="formDialog" @fillInOver="fillInOver" />
    <van-popup v-model="exchangeDialog" :close-on-popstate="true" :close-on-click-overlay="false" class="exchangeDialog">
        <div class="content">
            <p class="title">兑换码</p>
            <div class="input_box">
                <van-field v-model="codevalue" placeholder="请输入兑换码" />
            </div>
            <div class="btn_box">
                <div class="cancel" @click="exchangeDialog = false; codevalue = ''">取消</div>
                <div class="confirm" @click="uploadRedeemcodeInfo">确定</div>
            </div>
        </div>
    </van-popup>
    <BindMobile ref="bindMobile" />
</div>
</template>

<script>
import mOrderHeader from 'views/mobile/my/order/components/mOrderHeader'
import {uploadPayOrder, getOrderDetail} from 'api/api'
import {mapActions, mapGetters} from 'vuex'
import {uploadRedeemcodeInfo} from 'api/personalCenterApi'
import selectCoupon from './components/selectCoupon'
import FormDialog from '../../sort/course/components/formDialog'
import BindMobile from 'views/mobile/components/bindMobile/bindMobile'
export default {
    name: 'MConfirmOrder',
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=no' }
        ]
    },
    data() {
        return {
            init: false,
            kmctype: this.$route.query.kmctype ? this.$route.query.kmctype : '7',
            courseid: this.$route.query.cid ? this.$route.query.cid : '',
            qid: this.$route.query.qid ? this.$route.query.qid : '',
            reportid: this.$route.query.reportid ? this.$route.query.reportid : '',
            liveid: this.$route.query.liveid ? this.$route.query.liveid : '',
            item: {},
            selectCoupon: -1,
            discountmoney: '',
            saleprice: '',
            code: '',
            fillInForm: false,
            fillInArr: [],
            exchangeDialog: false,
            codevalue: '',
            agreement: false
        }
    },
    mounted() {
        this.courseid = this.qid || this.courseid || this.reportid || this.liveid;
        this.getView()
    },
    methods: {
        uploadRedeemcodeInfo() {
            if (this.codevalue) {
                this.setLoading(true)
                uploadRedeemcodeInfo({
                    data: {kmcinnerid: this.courseid, kmctype: this.item.kmctype, ordermoney: this.saleprice, redeemcodevalue: this.codevalue},
                    success: () => {
                        this.setLoading(false)
                        this.$toast.success('兑换成功')
                        // 题库
                        setTimeout(() => {
                            this.exchangeDialog = false
                            this.codevalue = ''
                            this.setRefresh(true)
                            if (this.kmctype === 8 || this.kmctype === '8') {
                                this.$router.push({name: 'PaperDetails', query: {qid: this.courseid}})
                            } else if(this.kmctype === 2 || this.kmctype === '2'){ //报告
                                this.$router.push({name: 'MReportDetails', query: {reportid: this.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                            } else if (this.kmctype === 3 || this.kmctype === '3') {
                                this.$router.push({name: 'MliveDetails', query: {liveid: this.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                            } else{ //课程
                                this.$router.push({name: 'MCourseView', query: {cid: this.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                            }
                        }, 1000)
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$toast.fail(res.msg)
                    }
                })
            } else {
                this.$toast.fail('请输入兑换码')
            }
            
        },
        fillInOver(arr) {
            this.fillInForm = true
            this.fillInArr = arr
            this.pay()
        },
        openSelectCoupon() {
            this.$refs.selectCoupon.open(this.item.couponvoucherlist, this.selectCoupon)
            // this.$refs.selectCoupon.open([], this.selectCoupon)
        },
        affirmCoupon(arr) {
            console.log(arr)
            if (arr.length) {
                this.item.couponvoucherlist.some((obj, index) => {
                    if (obj.couponvoucherid === arr[0]) {
                        this.selectCoupon = index
                        this.discountmoney = obj.discountmoney
                        this.saleprice = obj.ordermoney
                        return true
                    }
                })
            } else {
                this.saleprice = this.item.finalpayprice
                this.selectCoupon = -1
                this.discountmoney = ''
            }
        },
        // 打开兑换码
        changeExchangeDialog() {
            if (!this.user.isperfect) {
                this.$refs.bindMobile.showCheckBindMobile()
                return
            }
            this.exchangeDialog = true
        },
        pay() {
            if (!this.user.isperfect) {
                this.$refs.bindMobile.showCheckBindMobile()
                return
            }
            if (this.item.isform && !this.fillInForm) {
                this.$refs.formDialog.open(this.item.formlist)
            } else {
                if (this.agreement) {
                    this.setLoading(true)
                    let resulturl = window.location.protocol + '//' + window.location.host + this.$router.resolve({name: 'MPayResult'}).href
                    uploadPayOrder({
                        data: {
                            courseid: this.courseid,
                            kmctype: this.kmctype,
                            ordermoney: this.item.finalpayprice,
                            paymoney: this.saleprice,
                            resulturl: resulturl,
                            // channelid: this.channelid,
                            couponinnerid: this.selectCoupon !== -1 ? this.item.couponvoucherlist[this.selectCoupon].couponvoucherid : '',
                            discountmoney: this.selectCoupon !== -1 ? this.discountmoney : '',
                            userformlist: JSON.stringify(this.fillInArr),
                            channelid: this.$route.query.chid ? this.$route.query.chid : ''
                        },
                        success: data => {
                            this.setLoading(false)
                            this.$toast.success('操作成功！')
                            console.log(data)
                            if (data.code === '200') { // 订单号已存在
                                this.$dialog.confirm({
                                    title: '提示',
                                    message: '订单重复提交，去查看订单详情？'
                                }).then(() => {
                                    this.$router.push({name: 'MOrderView', query: {orderno: data.data.orderno}})
                                    // 题库
                                    // if (this.kmctype === 8 || this.kmctype === '8') {
                                    //     this.$router.push({name: 'PaperDetails', query: {orderno: data.data.orderno}})
                                    // } else if(this.kmctype === 2 || this.kmctype === '2'){ //报告
                                    //     this.$router.push({name: 'MReportDetails', query: {orderno: data.data.orderno}})
                                    // }else{ //课程
                                    //     this.$router.push({name: 'MOrderView', query: {orderno: data.data.orderno}})
                                    // }
                                }).catch(() => {
                                    this.$router.back()
                                })
                            } else {
                                if (data.data.ispaysuccess) {
                                    this.setRefresh(true)
                                    if (this.kmctype === 8 || this.kmctype === '8') {
                                        this.$router.push({name: 'PaperDetails', query: {qid: this.courseid}})
                                    } else if(this.kmctype === 2 || this.kmctype === '2'){ //报告
                                        this.$router.push({name: 'MReportDetails', query: {reportid: this.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                                    } else if (this.kmctype === 3 || this.kmctype === '3') {
                                        this.$router.push({name: 'MliveDetails', query: {liveid: this.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                                    } else{ //课程
                                        this.$router.push({name: 'MCourseView', query: {cid: this.courseid, chid: this.$route.query.chid ? this.$route.query.chid : ''}})
                                    }
                                } else {
                                    window.location.href = data.data.url
                                }
                            }
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$toast.fail(data.msg)
                        }
                    })
                } else {
                    this.$toast('请先同意服务协议')
                }
            }
        },
        getView() {
            this.setLoading(true)
            getOrderDetail({
                data: {
                    courseid: this.courseid ? this.courseid :  (this.qid ? this.qid : this.reportid),
                    kmctype: this.kmctype
                },
                success: data => {
                    this.setLoading(false)
                    this.init = true
                    // data.data.isbuyexpire = 1
                    // data.data.expiredays = 30
                    this.item = data.data
                    if (data.data.couponvoucherlist && data.data.couponvoucherlist.length) {
                        this.selectCoupon = 0
                        this.discountmoney = data.data.couponvoucherlist[0].discountmoney
                        this.saleprice = data.data.couponvoucherlist[0].ordermoney
                    } else {
                        this.selectCoupon = -1
                        this.discountmoney = ''
                        this.saleprice = data.data.finalpayprice
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'channelid',
            'user'
        ])
    },
    components: {
        mOrderHeader,
        selectCoupon,
        FormDialog,
        BindMobile
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~views/mobile/my/order/order";
.MConfirmOrder {
    .bottomMsgBox {
        position: fixed;
        bottom: 1.2rem;
        .checkBox {
            display: flex;
            align-items: flex-start;
            padding-left: 0.32rem;
            font-size: 0.18rem;
            line-height: 0.34rem;
            .van-checkbox {
                margin-right: 0.1rem;
            }
            .textBox {
                display: flex;
                flex-wrap: wrap;
                flex: 1;
            }
            .tips {
                font-size: 0.16rem;
            }
            a {
                color: $c-blue;
                white-space: pre-wrap;
            }
        }
    }
    .btnBox{
        .price {
            .name {
                font-size: 0.28rem;
            }
            .value {
                font-size: 0.36rem;
            }
        }
        .van-button {
            box-sizing: border-box;
            font-size: 0.3rem;
            background: $c-blue;
            line-height: 0.7rem;
            width: 2.2rem;
            height: 0.7rem;
            color: $c-white;
            border-radius: 0.38rem;
        }
    }
    .m-body {
        padding: 0 0.32rem;
        .box {
            .name {
                color: #999999;
            }
            line-height: 1.1rem;
            &:not(:last-of-type) {
                border-bottom: 0.01rem solid #DCDFE6;
            }
        }
        .nowprice, .coupon, .code {
            .value {
                color: #EC5E69;
            }
        }
        .couponCode {
            line-height: 1.1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
                color: #999999;
            }
            .right {
                display: flex;
                align-items: center;
                img {
                    width: 0.15rem;
                    height: 0.25rem;
                    margin-left: 0.2rem;
                }
                .discountmoney {
                    padding: 0.02rem 0.1rem;
                    border: 0.01rem solid #EC5E69;
                    font-size: 0.2rem;
                    height: 0.32rem;
                    line-height: 0.32rem;
                    text-align: center;
                    border-radius: 0.04rem;
                    color: #EC5E69;
                }
            }
        }
    }
    .exchange_tips {
        padding: 0.32rem;
        font-size: 0.28rem;
        color: #409EFF;
    }
    .exchangeDialog {
        border-radius: 0.15rem;
        .content {
            width: 5rem;
            height: 3.04rem;
            border-radius: 0.15rem;
            .title {
                text-align: center;
                padding: 0.4rem 0 0.28rem;
                font-size: 0.32rem;
                line-height: 0.45rem;
            }
            .input_box {
                padding: 0 0.32rem;
                margin-bottom: 0.32rem;
                .van-field {
                    width: 100%;
                    height: 0.68rem;
                    background: #F2F2F2;
                    border-radius: 0.06rem;
                    padding: 0.14rem 0.24rem;
                    box-sizing: border-box;
                    .van-field__control {
                        height: 0.4rem;
                    }
                }
            }
            .btn_box {
                display: flex;
                border-top: 0.01rem solid #E5E5E5;
                height: 0.92rem;
                div {
                    flex: 1;
                    height: 100%;
                    font-size: 0.32rem;
                    text-align: center;
                    line-height: 0.92rem;
                    color: #666666;
                }
                .confirm {
                    border-left: 0.01rem solid #E5E5E5;
                    color: #409EFF;
                }
            }
        }
    }
}
</style>